module.exports = __webpack_public_path__ + "img/devices.74bd4a01.svg";